import { getMetricTitle } from "../../../types/api/metrics/metricsType";
import { AvailableMetricResponse } from "../../../types/api/metrics/request";
import { Select } from "@primer/react";

interface MetricTypeSelectProps {
    metrics: AvailableMetricResponse[];
    value?: AvailableMetricResponse;
    onChange?: (value: AvailableMetricResponse) => void;
    placeholder?: string;
}

export const MetricTypeSelect: React.FC<MetricTypeSelectProps> = ({
    metrics,
    value,
    onChange
}) => {
    const getMetricId = (metric: AvailableMetricResponse) =>
        `${metric.metricName}_${metric.metricType}`;

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedMetricId = event.target.value;
        const selectedMetric = metrics.find(metric => getMetricId(metric) === selectedMetricId);
        if (selectedMetric) {
            onChange?.(selectedMetric);
        }
    };

    return (
        <Select value={value ? getMetricId(value) : ""} onChange={handleChange}>
            {metrics
                .filter(metric => metric.implemented)
                .map(metric => (
                    <Select.Option
                        key={getMetricId(metric)}
                        value={getMetricId(metric)}
                    >
                        {getMetricTitle(metric.metricName) + ` (${metric.metricType === 'detailed' ? 'Детализированный' : 'Агрегированный'} вариант)`}
                    </Select.Option>
                ))}
        </Select>
    );
};